import type { FormEvent, ChangeEvent, MouseEvent } from 'react';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useSearchBox } from 'react-instantsearch-core';
import styles from './Search.module.scss';
import Icon from '../../../../../../stories/Atoms/Icon/Icon';
import { document } from '../../../../../../js/globals';
import { useIsMobile } from '../../../../../general/hooks/useSize';
import useTranslate from '../../../../../general/Translation/hooks/UseTranslate';
import { useIsInitialRequestMobile } from '../../../../../general/WebshopContext/WebshopContext';

const Search: React.FC = () => {
  const { query, refine } = useSearchBox();
  const translate = useTranslate();

  const [refinement, setRefinement] = useState(query);

  const inputRef = useRef<HTMLInputElement | null>(null);
  const isMobileOrTablet = useIsMobile(useIsInitialRequestMobile());

  const refineValue = (newRefinement: string): void => {
    setRefinement(newRefinement);
    refine(newRefinement);
  };

  const submitSearch = (e: FormEvent<EventTarget>) => {
    e.preventDefault();
  };

  const onInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.currentTarget;
    refineValue(value);
  };

  const onSearchReset = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    refineValue('');
  };

  useEffect(() => {
    const onScrollEvent = () => {
      if (inputRef && inputRef.current) {
        inputRef.current.blur();
      }
    };

    if (isMobileOrTablet) {
      document?.body?.addEventListener('touchstart', onScrollEvent);
    }

    return () => {
      document?.body?.removeEventListener('touchstart', onScrollEvent);
    };
  }, [isMobileOrTablet]);

  return (
    <form
      className={styles.Search}
      onSubmit={submitSearch}
      name="search"
    >
      <input
        className={styles.Search__input}
        type="search"
        onChange={onInputChange}
        value={refinement}
        placeholder={translate('winkelmand_teksten', 'example_search')}
        ref={inputRef}
        autoComplete="off"
      />
      {refinement ? (
        <button
          className={styles.Search__button}
          onClick={onSearchReset}
          type="button"
          aria-label="Remove search"
        >
          <Icon name="fa-xmark" />
        </button>
      ) : (
        <button
          className={styles.Search__button}
          type="submit"
          aria-label="Search"
        >
          <Icon name="fa-magnifying-glass" />
        </button>
      )}
    </form>
  );
};

export default Search;
